export const IMAGES = [
  {
    image: require('../../assets/images/oldMan/card.png'),
  },
  {
    image: require('../../assets/images/oldMan/default.png'),
  },
  {
    image: require('../../assets/images/oldMan/hover.png'),
  },
  {
    image: require('../../assets/images/oldMan/right.png'),
  },
  {
    image: require('../../assets/images/oldMan/speaking.png'),
  },
  {
    image: require('../../assets/images/oldMan/stop.png'),
  },
  {
    image: require('../../assets/images/arrow_cursor.png'),
  },
  {
    image: require('../../assets/images/chat_cursor.png'),
  },
  {
    image: require('../../assets/images/computer-hover.png'),
  },
  {
    image: require('../../assets/images/computer-normal.png'),
  },
  {
    image: require('../../assets/images/curtain-close.png'),
  },
  {
    image: require('../../assets/images/curtain-half.png'),
  },

  {
    image: require('../../assets/images/curtain-open.png'),
  },
  {
    image: require('../../assets/images/eye_cursor.png'),
  },
  {
    image: require('../../assets/images/factory-open.png'),
  },
  {
    image: require('../../assets/images/factory_closed.png'),
  },
  {
    image: require('../../assets/images/hand_cursor.png'),
  },
  {
    image: require('../../assets/images/lock_cursor.png'),
  },
  {
    image: require('../../assets/images/mapp-front.png'),
  },
  {
    image: require('../../assets/images/mapp-inside.png'),
  },
  {
    image: require('../../assets/images/mapp-open.png'),
  },
  {
    image: require('../../assets/images/openrep_building.png'),
  },
  {
    image: require('../../assets/images/paper.png'),
  },
  {
    image: require('../../assets/images/reception.jpg'),
  },
  {
    image: require('../../assets/images/storeBg.png'),
  },
  {
    image: require('../../assets/images/window_scene.jpg'),
  },
  {
    image: require('../../assets/rec/rec1.png'),
  },
  {
    image: require('../../assets/rec/rec2.png'),
  },
  {
    image: require('../../assets/rec/rec3.png'),
  },
  {
    image: require('../../assets/rec/rec4.png'),
  },
  {
    image: require('../../assets/rec/rec5.png'),
  },
  {
    image: require('../../assets/rec/rec6.png'),
  },
  {
    image: require('../../assets/rec/rec7.png'),
  },
  {
    image: require('../../assets/rec/rec8.png'),
  },
  {
    image: require('../../assets/rec/rec9.png'),
  },
  {
    image: require('../../assets/rec/rec10.png'),
  },
  {
    image: require('../../assets/rec/rec11.png'),
  },
  {
    image: require('../../assets/rec/rec12.png'),
  },
  {
    image: require('../../assets/rec/rec13.png'),
  },
];

export const SOUNDS = [
  { sound: require('../../assets/sounds/bgm.mp3') },
  { sound: require('../../assets/sounds/computer-hover.mp3') },
  { sound: require('../../assets/sounds/curtain-hover.mp3') },
  { sound: require('../../assets/sounds/curtain-open.mp3') },
  { sound: require('../../assets/sounds/door-close.mp3') },
  { sound: require('../../assets/sounds/door-enter.mp3') },
  { sound: require('../../assets/sounds/door-open.mp3') },
  { sound: require('../../assets/sounds/old-1.mp3') },
  { sound: require('../../assets/sounds/hover.mp3') },
  { sound: require('../../assets/sounds/old-2.mp3') },
  { sound: require('../../assets/sounds/bot-1.mp3') },
  { sound: require('../../assets/sounds/lady-1.mp3') },
  { sound: require('../../assets/sounds/go-backroom.mp3') },
  { sound: require('../../assets/sounds/bot-2.mp3') },
  { sound: require('../../assets/sounds/bonichan.mp3') },
];

export const VIDEOS = [{ video: 'https://dskhnex0aho1n.cloudfront.net/public/walking.mp4' }, { video: 'https://dskhnex0aho1n.cloudfront.net/public/backroom-vid.mp4' }];
